import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './SearchBox.module.scss';
import { MagnifyingGlassIcon } from '../../../../lib/icons/MagnifyingGlass';
import { SearchBoxProps } from './Searchbox.types';

export const searchParam = '?search=';

const SearchBoxInput = ({
  ariaLabel,
  placeholder,
  ctaLabel,
  resultsPageLink,
}: Pick<SearchBoxProps, 'ariaLabel' | 'ctaLabel' | 'placeholder' | 'resultsPageLink'>) => {
  const [input, setInputValue] = useState('');

  const history = useHistory();
  const searchSuffix = `${resultsPageLink}${searchParam}${encodeURIComponent(input)}`;

  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const redirectToSearchPath = () => {
    history.push(searchSuffix);
  };

  const searchOnEnterKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      redirectToSearchPath();
    }
  };

  return (
    <>
      <div className={styles.inputContainer}>
        <input
          className={styles.searchInput}
          aria-label={ariaLabel || placeholder || ctaLabel}
          placeholder={placeholder}
          onChange={inputChange}
          onKeyDown={searchOnEnterKey}
        />
      </div>
      <button className={styles.button} type="button" aria-label={ctaLabel} onClick={redirectToSearchPath}>
        <MagnifyingGlassIcon className={styles.buttonIcon} />
        <span className={styles.ctaLabel}>{ctaLabel}</span>
      </button>
    </>
  );
};

export default SearchBoxInput;
